import React from "react";
import { OPEN_LINK_RETRY_HINT } from "../../../components/catalogue/catalogueViewerGate";

/** An open group link that failed to open. Never the invite password form: an open link has none. */
const CatalogueOpenFailed: React.FC<{ reason?: string }> = ({ reason }) => (
  <div className="hkp-shared-gate">
    <h2>This collection did not open</h2>
    <p className="hkp-shared-gate-lede">{reason || "Reload the page to try again."}</p>
    <button
      type="button"
      className="hkp-shared-gate-submit"
      onClick={() => window.location.reload()}
    >
      Reload
    </button>
    <p className="hkp-shared-gate-hint">{OPEN_LINK_RETRY_HINT}</p>
  </div>
);

export default CatalogueOpenFailed;
